import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useGameContext } from "../../../state/game/context";

const EventIdListener = () => {
	const { eventId } = useParams();
	const { initGameDataFromExternalEventId } = useGameContext();

	useEffect(() => {
		if (eventId) initGameDataFromExternalEventId(eventId);
	}, [eventId]);

	return null;
};

export default EventIdListener;
